import {
  SafeTag,
  PendingOffer,
  Alert,
  If,
  Loader
} from '@itau-loans-www/components'
import IconAviso from '@mobi/ds/static/icons/outlined/aviso.svg'
import IconSeguranca from '@mobi/ds/static/icons/outlined/seguranca.svg'

import Layout from '../../layouts/Summary'
import PendingForm from '../components/PendingForm'
import { usePendingData } from './hooks'
import './pending-data.scss'

const PendingData = () => {
  const {
    proposal,
    isLoading,
    submitLoading,
    closeAlert,
    isAlertVisible,
    handleSendProposal,
    initialValuesFromApi
  } = usePendingData()

  return (
    <Layout>
      <div className="pending-data container">
        <SafeTag />
        <Alert
          isVisible={isAlertVisible}
          paragraph={null}
          icon={<IconAviso />}
          message={`
            <h2>
              Inconsistência
            </h2>
            <p>
              Dados divergentes
            </p>
            `}
          closeAlert={closeAlert}
          variant="error"
        />
        <section className="pending-data__content">
          <h1 className="pending-data__title">
            Confirme seus dados para finalizar a contratação
          </h1>
          <p className="pending-data__subtitle">
            Identificamos inconsistências em alguns dados. Para dar
            continuidade, preencha corretamente os campos sinalizados.
          </p>

          <div className="pending-data__tip">
            <IconSeguranca />
            Não se preocupe, seus dados sempre estarão protegidos com o Itaú
          </div>

          <PendingOffer proposal={proposal} />
          <If
            condition={!isLoading}
            renderIf={
              <PendingForm
                initialValuesFromApi={initialValuesFromApi}
                handleSendProposal={handleSendProposal}
                submitLoading={submitLoading}
              />
            }
            renderElse={<Loader visible hasOverlay />}
          />
        </section>
      </div>
    </Layout>
  )
}

export default PendingData
